import { RequestDocument, Variables } from 'graphql-request/dist/types'
import { Response, useAuth, useMutation } from '@aposphaere/core-kit'

export const useAuthenticatedMutation = <ModelType>(query: RequestDocument): ((variables: Variables) => Promise<Response<ModelType>>) => {
  const auth = useAuth()
  const headers = new Headers({ Authorization: auth.token })
  return useMutation<ModelType>(query, headers)
}
